module.exports = __webpack_public_path__ + "1a11e266b8ff070a6c4e108d3a5dcf87.pdf";